import { render, staticRenderFns } from "./ListChapterSketelon.vue?vue&type=template&id=55737e8d&scoped=true&"
import script from "./ListChapterSketelon.vue?vue&type=script&lang=js&"
export * from "./ListChapterSketelon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55737e8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
